<script>
  import radio from '~componentes/Radio.vue';

  export default {
    components: { radio },
    props: {
      pagamento: {
        type: Object,
        required: true
      },
    },
    data() {
      return {}
    },
    methods: {
      validar() {
        return this.$validator.validateAll();
      },
      nomeCartaoCompleto() {
        return false;
      },
    },
    computed: {},
    mounted() {
    },
    created() {
    }
  }
</script>

<template>
  <div>
    <form @submit.prevent="">
      <div class="row">
        <div class="col-md-4">
          <div class="form-group required" :class="{'has-error': errors.has('nome-cartao')}">
            <label for="nome-cartao" class="control-label">Nome no cartão</label>

            <input type="text"
                   class="form-control"
                   id="nome-cartao"
                   v-model="pagamento.nome"
                   data-vv-as="nome no cartão"
                   data-vv-name="nome-cartao"
                   style="text-transform: uppercase;"
                   v-validate="`required|nomecompleto`">

            <p class="text-danger" v-show="errors.has('nome-cartao')">{{ errors.first('nome-cartao') }}</p>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group required" :class="{'has-error': errors.has('numero-cartao')}">
            <label for="numero-cartao" class="control-label">Número do cartão</label>

            <input type="text"
                   class="form-control"
                   id="numero-cartao"
                   v-model="pagamento.numeroCartao"
                   data-vv-as="número do cartao"
                   data-vv-name="numero-cartao"
                   v-numero
                   maxlength="16"
                   v-validate="`required|numerocartao|numerocartaovalido`">

            <p class="text-danger" v-show="errors.has('numero-cartao')">{{ errors.first('numero-cartao') }}</p>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group required" :class="{'has-error': errors.has('vencimento-cartao')}">
            <label for="vencimento-cartao" class="control-label">Vencimento do cartão</label>

            <input type="text"
                   class="form-control"
                   id="vencimento-cartao"
                   v-model="pagamento.vencimentoCartao"
                   data-vv-as="vencimento do cartão"
                   data-vv-name="vencimento-cartao"
                   v-mascara="'mes-ano'"
                   v-validate="`required|datacartaovalido`">

            <p class="text-danger" v-show="errors.has('vencimento-cartao')">{{ errors.first('vencimento-cartao') }}</p>
          </div>
        </div>
        <div class="col-md-2">
          <div class="form-group required" :class="{'has-error': errors.has('cvv')}">
            <label for="cvv" class="control-label">CVV</label>

            <input type="text"
                   class="form-control"
                   id="cvv"
                   v-model="pagamento.cvv"
                   data-vv-as="cvv"
                   data-vv-name="cvv"
                   maxlength="4"
                   v-numero
                   v-validate="`required|cvvvalido`">

            <p class="text-danger" v-show="errors.has('cvv')">{{ errors.first('cvv') }}</p>
          </div>
        </div>
        <div class="col-sm-12">
          <div class="form-group radios">
            <radio v-model="pagamento.tipoDocumentoCartao"
                   selected-value="CPF"
                   type="success"
                   :inline="true"
                   class="no-margin-top no-margin-bottom margin-right-10">
              Pessoa Física
            </radio>
            <radio v-model="pagamento.tipoDocumentoCartao"
                   selected-value="CNPJ"
                   type="success"
                   :inline="true"
                   disabled
                   v-if="false"
                   class="no-margin-top no-margin-bottom">
              Pessoa Jurídica
            </radio>
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group required" :class="{'has-error': errors.has('documento')}">
            <label for="documento" class="control-label">{{ pagamento.tipoDocumentoCartao }} do dono do cartão</label>

            <input type="text"
                   class="form-control"
                   id="documento"
                   v-model="pagamento.documento"
                   data-vv-as="documento"
                   data-vv-name="documento"
                   v-mascara="pagamento.tipoDocumentoCartao.toLocaleLowerCase()"
                   v-validate="`required|${pagamento.tipoDocumentoCartao.toLocaleLowerCase()}`">

            <p class="text-danger" v-show="errors.has('documento')">{{ errors.first('documento') }}</p>
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group required" :class="{'has-error': errors.has('data-nascimento-cartao')}">
            <label for="data-nascimento-cartao" class="control-label">Data de nascimento do dono do cartão</label>

            <input type="text"
                   class="form-control"
                   id="data-nascimento-cartao"
                   v-model="pagamento.dataNascimento"
                   data-vv-as="data de nascimento do dono do cartão"
                   data-vv-name="data-nascimento-cartao"
                   v-mascara="'data'"
                   v-validate="`required|date_format:DD/MM/YYYY`">

            <p class="text-danger" v-show="errors.has('data-nascimento-cartao')">{{ errors.first('data-nascimento-cartao') }}</p>
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group required" :class="{'has-error': errors.has('telefone')}">
            <label class="control-label" for="telefone">Telefone</label>

            <input type="text"
                   class="form-control"
                   id="telefone"
                   v-mascara="'telefone'"
                   v-model="pagamento.telefone"
                   data-vv-as="telefone"
                   data-vv-name="telefone"
                   maxlength="20"
                   v-validate="'required'">

            <p class="text-danger" v-show="errors.has('telefone')">{{ errors.first('telefone') }}</p>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/acessos/componentes/compartilhado/AcessosInscricaoCartaoCredito.vue